export const simple = process.env.REACT_APP_URL_SIMPLE;
export const ripleyBank = process.env.REACT_APP_URL_BANCO;
export const ripleyGoPoints = process.env.REACT_APP_URL_PUNTOS;
export const ripleyInsurance = process.env.REACT_APP_URL_SEGUROS;
export const ripleyBankPayAccount = process.env.REACT_APP_URL_PAY_ACCOUNT;
export const forgottenPassword = process.env.REACT_APP_FORGOTTEN_PASSWORD;

export const terms = process.env.REACT_APP_TERMS_AUTHORIZATION;
export const privacyPolicies = process.env.REACT_APP_PRIVACY_POLICIES;
export const frecuentQuestions = process.env.REACT_APP_URL_FRECUENT_QUESTIONS;
export const getIssuesFilesBasePath =
  process.env.REACT_APP_URL_ISSUES_IMAGES_BASE_PATH;
export const legalRPGOBank = process.env.REACT_APP_LEGAL_RPGO_BANK;
export const contactBackBff = process.env.REACT_APP_BFF_BASE_URL;
export const apiCucaIncidentBff =
  process.env.REACT_APP_CUCA_INCIDEDNT_BFF_BASE_URL;
export const ripleyReturnPeriods = process.env.REACT_APP_URL_RETURN_PERIODS;
export const whatsAppLineContact = process.env.REACT_APP_WHATSAPP_LINE;
